import { ErrorPage } from "../error-page.component";
import { withShowIf } from "../../with-show-if/with-show-If.component";

export const ErrorPage404 = withShowIf(() => {
  return (
    <ErrorPage
      title="404"
      subTitle="This document could not be found"
      text="The reason you are seeing this message is because the document was either removed or does not exist."
    />
  );
});
